<template>
  <NuxtLayout name="sticky">
    <template #header>
      <CmsHeader v-bind="{ title }" :loading="getIsClient() && isLoading" />
    </template>

    <div v-if="getIsClient() && isLoading" class="flex flex-col gap-100">
      <template v-for="i in 4" :key="i">
        <LcSkeleton class="mb-100" height="1.625rem" radius="medium" width="40%" />
        <LcSkeleton class="mb-050" height="0.75rem" radius="medium" />
        <LcSkeleton class="mb-050" height="0.75rem" radius="medium" />
        <LcSkeleton class="mb-200" height="0.75rem" radius="medium" width="40%" />
      </template>
    </div>
    <CmsContent v-else :data="page" />
  </NuxtLayout>
</template>

<script lang="ts" setup>
import type { ContentBlock } from '#content/shared/@types/generated/cms/graphql-schema-types'

const isContentBlock = (property: unknown): property is ContentBlock =>
  (property as ContentBlock).__typename === 'ContentBlock'

const route = useRoute()
const { defaultLocale, locales } = useI18n()

const normalizedRoute = computed(() => {
  const locale = locales.value.find((locale) => locale.code !== defaultLocale)
  if (locale && route.path.startsWith(`/${locale.code}/`)) {
    return route.path.slice(locale.code.length + 1)
  }
  return route.path
})

const { data, error, pending } = useContent().getPage(normalizedRoute.value)
const isLoading = useMinimumLoading(pending)

const page = computed(() => data.value?.contentBlocksCollection?.items.filter(isContentBlock) ?? [])
const title = computed(() => data.value?.title || '')

watchImmediate(error, () => {
  if (!error.value) return
  show404Error()
})
</script>
